export const iconList = ['plane', 'bug', 'coffee', 'bell', 'calendar', 'home'];
